export const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST as string,
  defaults: '2026-01-30',
} as const;

export const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN as string;
